import React from 'react'
import { Link } from 'react-router-dom'

function SubFooter() {
  return (
    <div className="content-section home-area black-back">
        <div className="container standard-tour-list ">
            <div className="row inner-section">
                <div className="col-md-6">
                    <h3 className="ft40">Stephenson <span className="txtgold">Adventures</span></h3>
                </div>
                <div className="col-md-6">
                    <div className="quot-block">
                     <div className="quote-text"> “If I have ever seen magic, it has been in Africa.”</div> <span className="txtgold"> John Hemmingway</span>
                    </div>
                </div>
            </div>
            <div className="row inner-section sub-footer-area">
                 <div className="col-md-3">
                 <h4 className="title-foot">Find Out</h4>
                    <ul className="footnav-bar">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/shop">Shop</Link>
                        </li>
                        <li className="nav-item">
                        <Link className="nav-link" to="/contact-us">Contact Us</Link>
                        </li> 
                        <li className="nav-item">
                        <Link className="nav-link" to="/about">About Us</Link>
                        </li>                         
                    </ul>
                 </div>
                 <div className="col-md-3">
                     <h4 className="title-foot">Confidentiality</h4>
                    <ul className="footnav-bar">
                        <li className="nav-item">
                            <Link className="nav-link" to="/faq">FAQ</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/policy">Policy</Link>
                        </li> 
                        <li className="nav-item">
                            <Link className="nav-link" to="/terms-and-conditions">Terms and Condition</Link>
                        </li>
                    </ul>
                 </div>
                 <div className="col-md-3">
                    <h4 className="title-foot">User Account</h4>
                    <ul className="footnav-bar">
                        <li className="nav-item">
                            <Link className="nav-link" to="/profile">Profile</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/forum">Forum</Link>
                        </li> 
                        <li className="nav-item">
                            <Link className="nav-link" to="/help-center">Help Center</Link>
                        </li>

                    </ul>
                 </div>
                 <div className="col-md-3">
                     <h4 className="title-foot">Variety</h4>
                    <ul className="footnav-bar">
                        <li className="nav-item">
                            <Link className="nav-link" to="/shop">Gallery</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/site-map">Site Map</Link>
                        </li> 
                       
                        <li className="nav-item">
                          <Link className="nav-link" to="/contact-us">Career</Link>
                        </li> 
                    </ul>
                 </div>
            </div>
        </div>
    </div>
  )
}

export default SubFooter